/**
 * @desc 保存部门
 */
import { DeptEntity, DeptForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateDeptParameter = DeptForm

const method = 'POST'
const url = '/auth/dept'

export const createDeptApi = (
  data?: CreateDeptParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<DeptEntity>({
    method,
    url,
    data,
    ...config
  })
}

createDeptApi.method = method
createDeptApi.url = url
